export default __webpack_public_path__ + "static/media/phone-call.9507d200.png";